import { HasDependencies, hashString } from '../../api/types';
import { ApiUser, FirebaseUser } from '../../api/user/types';
import { Domains } from '../../constants';
import { BaseTracker } from './baseTracker';

/**
 * Firebase user actions
 */
export class UserTracker implements HasDependencies {
  constructor(readonly tracker: BaseTracker) {}

  public getDeps = () => [hashString([...this.tracker.getDeps()])];

  public trackFirebaseLogin = (
    user: FirebaseUser,
    userInfo: ApiUser | null
  ) => {
    const { email, displayName } = user;

    if (email) {
      this.tracker.mixpanel.actions.register({
        TokenEmail: email,
        $name: displayName,
      });
      this.tracker.mixpanel.actions.identify(email);
      this.tracker.track('[User] Signed In (3rd party Auth)', {
        uid: user.uid,
        $email: userInfo?.email ?? user.email,
      });
    }
  };

  public trackFirebaseLogout = (user: FirebaseUser, domain: Domains | null) => {
    if (user) {
      // Clear identity and super props to avoid cross-user leakage
      this.tracker.mixpanel.actions.reset();
      this.tracker.mixpanel.actions.unregister('TokenEmail');
      this.tracker.track('[User] Signed Out (3rd party Auth)', {
        uid: user.uid ?? user.email,
        $email: user.email,
        domain,
      });
    }
  };

  /**
   * App user actions. Difference from Firebase user actions is that e.g. a firebase login might succeed but the app doesn't know the user so the app login fails.
   */

  public trackAppLogin = (email: string | undefined) => {
    if (email) {
      this.tracker.mixpanel.actions.register({ TokenEmail: email });
      this.tracker.mixpanel.actions.identify(email);
      this.tracker.track('[User] Signed In', {
        uid: email,
        $email: email,
      });
    }
  };
}
